import React from 'react'

import PropTypes from 'prop-types'

import Header from './header'
import Footer from './footer'
import Whatsapp from './whatsapp'
import './rea.css'

const Rea = (props) => {
  return (
    <div className={`rea-container1 ${props.rootClassName} `}>
      <main className="rea-container2">
        <div className="rea-container3">
          <Header rootClassName="headerroot-class-name5"></Header>
          <div className="rea-container4">
            <div className="rea-frame46">
              <span className="rea-text1">ÁREA DE ATUAÇÃO</span>
              <span className="rea-text2">{props.titulo}</span>
              <span className="rea-text3 Content">{props.descricao}</span>
            </div>
            <div className="rea-container5">
              <span className="rea-text4">
                <span>Fale Comigo</span>
              </span>
              <span className="rea-text6 Content">
                Quer saber mais sobre esta área de atuação? Mande-me uma
                mensagem para introduzirmos esta questão
              </span>
              <iframe
                src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                className="rea-iframe"
              ></iframe>
            </div>
          </div>
        </div>
        <div className="rea-container6">{props.children}</div>
        <Footer rootClassName="footerroot-class-name"></Footer>
        <Whatsapp></Whatsapp>
      </main>
    </div>
  )
}

Rea.defaultProps = {
  titulo: 'Titulo',
  descricao: 'Descrição',
  rootClassName: '',
}

Rea.propTypes = {
  titulo: PropTypes.string,
  descricao: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Rea
